import {
  tokens,
  makeStyles,
  shorthands,
  Card,
  Text,
  Button,
  MessageBar,
  MessageBarBody,
} from '@fluentui/react-components';
import { ShieldKeyholeRegular } from '@fluentui/react-icons';
import { APP_NAME, APP_DESCRIPTION } from '../constants';

const useStyles = makeStyles({
  page: {
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'center',
    alignItems: 'center',
    minHeight: '100vh',
    background: '#f5f5f5',
    ...shorthands.padding('24px'),
  },
  card: {
    maxWidth: '420px',
    width: '100%',
    ...shorthands.padding('48px', '40px'),
    ...shorthands.borderRadius('16px'),
    boxShadow: '0 2px 12px rgba(0, 0, 0, 0.08), 0 0 1px rgba(0, 0, 0, 0.1)',
    textAlign: 'center',
    border: 'none',
  },
  iconWrap: {
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    width: '64px',
    height: '64px',
    ...shorthands.borderRadius('16px'),
    backgroundColor: tokens.colorBrandBackground,
    color: '#fff',
    marginLeft: 'auto',
    marginRight: 'auto',
    marginBottom: '24px',
  },
  title: {
    fontSize: '24px',
    fontWeight: 700,
    color: tokens.colorNeutralForeground1,
    marginBottom: '8px',
  },
  description: {
    fontSize: '14px',
    color: tokens.colorNeutralForeground3,
    lineHeight: '20px',
    marginBottom: '32px',
  },
  signInBtn: {
    width: '100%',
    height: '44px',
    fontSize: '15px',
    fontWeight: 600,
    ...shorthands.borderRadius('8px'),
  },
  errorBar: {
    marginBottom: '16px',
    textAlign: 'left',
  },
  footer: {
    marginTop: '24px',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    gap: '6px',
    fontSize: '12px',
    color: tokens.colorNeutralForeground4,
  },
});

interface SignInScreenProps {
  onSignIn: () => void;
  error?: string | null;
}

export function SignInScreen({ onSignIn, error }: SignInScreenProps) {
  const styles = useStyles();

  return (
    <div className={styles.page}>
      <Card className={styles.card}>
        <div className={styles.iconWrap}>
          <ShieldKeyholeRegular fontSize={32} />
        </div>
        <Text className={styles.title} block>
          {APP_NAME}
        </Text>
        <Text className={styles.description} block>
          {APP_DESCRIPTION}
        </Text>
        {error && (
          <MessageBar intent="error" className={styles.errorBar}>
            <MessageBarBody>{error}</MessageBarBody>
          </MessageBar>
        )}
        <Button
          appearance="primary"
          className={styles.signInBtn}
          onClick={onSignIn}
        >
          Sign in with Microsoft
        </Button>
        <div className={styles.footer}>
          <ShieldKeyholeRegular fontSize={14} />
          Protected by Microsoft Entra ID
        </div>
      </Card>
    </div>
  );
}
